import { render, staticRenderFns } from "./TruckDefaultCrew.vue?vue&type=template&id=5e8af1da&scoped=true"
import script from "./TruckDefaultCrew.vue?vue&type=script&lang=js"
export * from "./TruckDefaultCrew.vue?vue&type=script&lang=js"
import style0 from "./TruckDefaultCrew.vue?vue&type=style&index=0&id=5e8af1da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8af1da",
  null
  
)

export default component.exports